var _excluded = ["isExternal", "target", "rel", "className"],
  _excluded2 = ["className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { tqc, forwardRef } from '../../system';
import { cx } from '../../utils';
import * as React from 'react';
export var LinkOverlay = forwardRef((props, ref) => {
  var {
      isExternal,
      target,
      rel,
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(tqc.a, _extends({}, rest, {
    ref: ref,
    className: cx('tqc-linkbox__overlay', className),
    rel: isExternal ? 'noopener noreferrer' : rel,
    target: isExternal ? '_blank' : target,
    __css: {
      position: 'static',
      '&::before': {
        content: "''",
        cursor: 'inherit',
        display: 'block',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 0,
        width: '100%',
        height: '100%'
      }
    }
  }));
});
/**
 * `LinkBox` is used to wrap content areas within a link while ensuring semantic html
 * @see Resources https://www.sarasoueidan.com/blog/nested-links
 */
export var LinkBox = forwardRef((props, ref) => {
  var {
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement(tqc.div, _extends({
    ref: ref,
    position: "relative"
  }, rest, {
    className: cx('tqc-linkbox', className),
    __css: {
      /* Elevate the links and abbreviations up */
      'a[href]:not(.tqc-linkbox__overlay), abbr[title]': {
        position: 'relative',
        zIndex: 1
      }
    }
  }));
});